import { render, staticRenderFns } from "./ResourcesTrainingHeader.vue?vue&type=template&id=0e436c13&"
import script from "./ResourcesTrainingHeader.vue?vue&type=script&lang=js&"
export * from "./ResourcesTrainingHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports